// @ts-check
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { getMessageConstructor } from '../messageFactory';
import EmptyState from '../messageFactory/EmptyState';
import Text from 'components/base/Text';
import { verticalScroller } from 'components/base/scroller';
import _ from 'lodash';
import { LBButton } from '@linearb/buzz';

const StyledMenuWrapper = styled.div`
  width: 42rem;
  max-height: 35rem;
  ${verticalScroller()}
  margin-right: 0.3rem;
`;

const StyledMenuHeaderWrapper = styled(Flex)`
  line-height: 2rem !important;
  padding: 2rem;
  overflow: hidden;
`;

const MessageCenterMenuWrapper = ({
  menuItems,
  markAsRead,
  deleteMessage,
  addRepositories,
  openRepositoriesModal,
  license
}) => {
  const noMessages =
    menuItems?.find(menuItem => !menuItem.is_read) === undefined;

  return (
    <Flex direction='column' overflow='hidden' pb='medium'>
      <StyledMenuHeaderWrapper items='center' justify='space-between'>
        <Text size='large' weight='400'>
          Messages
        </Text>
        <LBButton
          variant='ghost'
          onClick={() => {
            markAsRead(
              menuItems.map(({ dedup_key }) => dedup_key),
              'all'
            );
          }}
        >
          {!noMessages && <>Mark all as read</>}
        </LBButton>
      </StyledMenuHeaderWrapper>
      <StyledMenuWrapper>
        {noMessages ? (
          <EmptyState />
        ) : (
          menuItems
            .map((props, idx) => {
              const type = _.get(props, 'type', null);
              if (!type) {
                return null;
              }
              const Message = getMessageConstructor(type);

              return Message ? (
                <Message
                  key={idx}
                  {...props}
                  markAsRead={markAsRead}
                  deleteMessage={deleteMessage}
                  addRepositories={addRepositories}
                  openRepositoriesModal={openRepositoriesModal}
                  license={license}
                  isRead={props.is_read}
                  date={props.created_at}
                  id={props.dedup_key}
                />
              ) : null;
            })
            .filter(Boolean)
        )}
      </StyledMenuWrapper>
    </Flex>
  );
};

const renderMessageCenterItems = ({
  menuItems,
  markAsRead,
  deleteMessage,
  addRepositories,
  openRepositoriesModal,
  license
}) => {
  return (
    <li key='messageCenterItems'>
      <MessageCenterMenuWrapper
        menuItems={menuItems}
        markAsRead={markAsRead}
        deleteMessage={deleteMessage}
        addRepositories={addRepositories}
        openRepositoriesModal={openRepositoriesModal}
        license={license}
      />
    </li>
  );
};

export default renderMessageCenterItems;
